import { httpClient } from '@core/http/httpClient';
import { AxiosResponse } from 'axios';

export const downloadFile = ({ file, fileName }: { file?: Blob; fileName?: string }) => {
  if (!fileName || !file) {
    return;
  }
  const url = window.URL.createObjectURL(file);
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.href = url;
  a.download = fileName;
  a.click();
};

export const getFileFromResponse = (response: AxiosResponse) => {
  if (response.headers['content-disposition']) {
    const fileNameRegex = `filename[^;\n=]*=([^;\n]*)`;
    const fileName = response.headers['content-disposition']?.match(fileNameRegex)[1].replace(/['"]+/g, '');
    const file = new Blob([response.data], {
      type: response.headers['content-type'],
    });
    return {
      file: file,
      fileName: fileName,
    } as { file: Blob; fileName: string };
  }
  return {
    file: response.data,
    fileName: 'download',
  } as { file: Blob; fileName: string };
};

export const downloadAndGetFileFromUrl = async (url: string, fileName: string) => {
  if (!url || !fileName) {
    return;
  }
  const response = await httpClient.get(url);
  url = window.URL.createObjectURL(new Blob([response.data]));
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.href = url;
  a.download = fileName;
  a.click();

  document.body.removeChild(a);
};

export const downloadFileFromUrl = (url: string, fileName: string) => {
  if (!url || !fileName) {
    return;
  }
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.href = url;
  a.download = fileName;
  a.click();

  document.body.removeChild(a);
};
